/**
 * executionAdapters/convertAdapter.ts
 *
 * Execution adapter for the CONVERT workflow.
 * Files are already in the folder — only rename (if needed).
 * BL attachment is handled by the converter module via creativeAttach.
 */

import { api } from '../../../../general/apiScenarios';
import type { PreparedFile, FileExecutionResult } from '../contracts';

/**
 * Rename a file inside the creative folder if its name differs from the target.
 * Does NOT create BL entity — the converter does it via `creativeAttach` in batch.
 */
export async function renameForConvert(
  file: PreparedFile,
  signal: AbortSignal,
): Promise<FileExecutionResult> {
  if (!file.nodeRef) {
    return { success: false, fileId: file.id, error: 'No node reference' };
  }

  // Skip rename if already correct
  if (file.originalName === file.newFilename) {
    return { success: true, nodeId: file.nodeRef.id };
  }

  const renameResult = await api.fs.rename(file.newFilename, file.nodeRef.id);
  if (signal.aborted) return { success: false, fileId: file.id, error: 'Aborted' };

  if (!renameResult.success) {
    return { success: false, fileId: file.id, error: 'Rename failed' };
  }

  return { success: true, nodeId: file.nodeRef.id };
}
